import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

/**
 * GREAT LIBRARY (Библиотека) — a hushed tower-library, the quiet scholarly heart of Castle Hearthhold.
 * Tall arched BOOKCASES line the north wall (the hero wall), a candelabra throws a soft warm pool over a
 * small reading TABLE flanked by two facing reading chairs, and a lone armchair sits in a window nook by
 * the west wall. Scroll shelves and a fern keep the stone from reading cold. Faint, quiet, scholarly.
 *
 * Geometry: zone (40,40) 260×360 → interior x52..288, y52..388, centre (170,220). Door on the SOUTH wall
 * at x170 (gap x110..230) — kept clear (nothing placed across the south mouth).
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // ── HERO: tall arched bookcases — two along the NORTH wall + one on the EAST wall (fill, not empty). ──
  place(ctx, kit.bookcase(art, 128), 96, 118);
  place(ctx, kit.bookcase(art, 128), 208, 118);
  place(ctx, kit.bookcase(art, 116), 256, 250);

  // ── Scroll shelf on the WEST wall — overflow reading. ──
  place(ctx, kit.scrollShelf(art, 64, 84), 70, 300);

  // ── The reading TABLE on a warm woven rug, flanked by two facing reading chairs (the sit anchors). ──
  place(ctx, f.rug(art, 150, 96), 175, 232);
  place(ctx, kit.woodChair(art, 0), 140, 230); // library-read-l, facing east
  place(ctx, kit.smallTable(art, 30), 175, 232); // table between the readers
  place(ctx, kit.woodChair(art, Math.PI), 210, 230); // library-read-r, facing west

  // ── The window-nook ARMCHAIR by the west wall, facing the window (north). ──
  place(ctx, kit.woodChair(art, -Math.PI / 2), 90, 340); // library-armchair

  // ── Warm candlelight over the reading table — the one soft pool in a stone tower. ──
  place(ctx, kit.candelabra(art), 175, 205);

  // ── A single wall torch on the EAST wall for warm edge light. ──
  place(ctx, kit.wallTorch(art), 262, 140);

  // ── Fill the lower floor: a study lectern with an open tome + a fern, so no zone reads as bare stone. ──
  place(ctx, kit.lectern(art), 110, 330);
  place(ctx, f.plant(art, 'fern'), 250, 344);
};

export default decorate;
